@if (pageContent) {
    <div>
        <h2>{{ pageContent.name }}</h2>
        <p [innerHTML]="pageContent.content"></p>
    </div>
} @else {
    <p>No content available</p>
}
